/**
 * Process & Finalise Attendance — Run Payroll–style steps.
 * Apply Leave is omitted when process scope is only Auto-present (Manual Override) policies.
 */
export const ATTENDANCE_PROCESS_STEPS = [
  {
    key: "change_status",
    label: "Change Status",
    description:
      "Select employees, open the calendar, then use Previous / Next to move through only that selection and update day statuses.",
  },
  {
    key: "apply_leave",
    label: "Apply Leave",
    description:
      "Apply leave for punch / automated-policy employees. Hidden when scope is Auto-present only.",
    omitForAutoPresentOnly: true,
  },
  {
    key: "lop_reversal",
    label: "LOP Reversal",
    description: "Pick an employee and reverse LOP days in the selected month.",
    bodyHint: "No LOP reversals saved for the selected month. Use Actions → LOP Reversal to add entries.",
  },
  {
    key: "reconciliation",
    label: "Reconciliation",
    description: "Review leave and LOP headcounts for the month (tabs).",
  },
  {
    key: "process",
    label: "Process Attendance",
    description:
      "Register summary with status totals, process / unprocess, policy scope, and Excel export (quick reports).",
  },
  {
    key: "checklist",
    label: "Checklist",
    description: "Complete month checklist tasks defined under Attendance Checklist.",
  },
  {
    key: "preview_validate",
    label: "Preview & Validate",
    description: "Summary cards for all steps, plus exceptions for punch / automated policies.",
  },
  {
    key: "finalise",
    label: "Finalise Attendance",
    description: "Lock the attendance month so payroll can consume paid days.",
  },
];

/**
 * @param {string} payMonth YYYY-MM
 * @param {{ includeApplyLeave?: boolean }} [opts]
 */
export function createInitialAttendanceProcessState(payMonth, opts = {}) {
  const includeApplyLeave = opts.includeApplyLeave !== false;
  const catalog = ATTENDANCE_PROCESS_STEPS.filter(
    (s) => !(s.omitForAutoPresentOnly && !includeApplyLeave)
  );
  return {
    payMonth: payMonth || new Date().toISOString().slice(0, 7),
    activeStepKey: catalog[0]?.key || "change_status",
    status: "draft",
    steps: catalog.map((s) => ({
      ...s,
      status: "pending",
      resultJson: null,
    })),
    scopeMode: "all",
    selectedPolicyIds: [],
    finalisedAt: null,
  };
}

export function getAttendanceProcessSteps(includeApplyLeave = true) {
  return ATTENDANCE_PROCESS_STEPS.filter(
    (s) => !(s.omitForAutoPresentOnly && !includeApplyLeave)
  );
}
